export default __webpack_public_path__ + "static/about-monica-old-cropped-16-9-ratio-115102d91bf44c5e49c6d9fc63aa07c9.png";